import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Emoji } from './Emoji';
type CtaButtonProps = {
  children: React.ReactNode;
  emoji?: string;
  variant?: 'primary' | 'outline';
  href?: string;
  pulse?: boolean;
  className?: string;
};
export function CtaButton({
  children,
  emoji,
  variant = 'primary',
  href = '#plan-sistema-total',
  pulse = true,
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-4 text-center font-display text-base font-extrabold uppercase tracking-tight transition-[background-color,color,border-color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime-400 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-900 sm:text-lg';
  const variants = {
    primary: 'bg-lime-500 text-forest-950 hover:bg-lime-400',
    outline: 'border-2 border-lime-400/50 text-lime-200 hover:border-lime-400 hover:bg-lime-400/10'
  };
  return <a href={href} className={[base, variants[variant], pulse && variant === 'primary' ? 'cta-latente' : '', className].join(' ')} data-id="element-69" data-mp="35xxt0rx2krtt">
      {emoji ? <Emoji symbol={emoji} data-id="element-70" data-mp="3exku1clvzvmc" /> : null}
      <span style={{
      fontSize: "14px"
    }} data-id="element-71" data-mp="3ewj647jrven7">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-72" data-mp="3jx78tqhd5jx9" />
    </a>;
}